// extracted by mini-css-extract-plugin
export default {"form":"signup_form__lTPhj","publicBg":"signup_publicBg__MHOuG"};